import { PeriodUnit } from 'modules/onboarding/lib/pricing/types'
import type ChargebeeAddon from './ChargebeeAddon'

export type PricingType = {
  [Key in PeriodUnit]: {
    perSeat?: ChargebeeAddon
    fee?: ChargebeeAddon
    tiered?: ChargebeeAddon
    stairstep?: ChargebeeAddon
  }
}

export class Pricing {
  private _discount = 0
  constructor(
    private month: PricingType['month'],
    private year: PricingType['year']
  ) {}

  get currency() {
    return (
      this.month.perSeat?.currency || this.month.fee?.currency || this.month.stairstep?.currency
    )
  }

  isPerSeat(period: PeriodUnit) {
    const periodPricing = this[period]
    return !!periodPricing.perSeat || !periodPricing.fee || periodPricing.stairstep
  }

  getPlanId(period: PeriodUnit) {
    const periodPricing = this[period]
    return periodPricing.perSeat?._id || periodPricing.fee?._id || periodPricing.stairstep?._id
  }

  setDiscount(discount: number) {
    this._discount = discount
  }

  getSeatsPrice(period: PeriodUnit) {
    const periodPricing = this[period]
    return periodPricing.perSeat?.getMonthlyPrice()
  }

  getFeePrice(period: PeriodUnit) {
    const periodPricing = this[period]
    return periodPricing.fee?.getMonthlyPrice() || 0
  }

  getTieredPrice(period: PeriodUnit) {
    const periodPricing = this[period]
    return periodPricing.tiered?.tiers
  }

  getStairstepPrice(period: PeriodUnit) {
    const periodPricing = this[period]
    return periodPricing.stairstep?.getMonthlyPrice() || 0
  }

  getTotalPrice(period: PeriodUnit, seats: number) {
    const periodPricing = this[period]

    const seatsPrice = periodPricing.perSeat?.getPrice(seats) || 0
    const feePrice = periodPricing.fee?.getPrice() || 0
    const tieredPrice = periodPricing.tiered?.getPrice() || 0
    const stairstepPrice = periodPricing.stairstep?.getPrice() || 0
    const discount = this._discount

    return seatsPrice + feePrice + tieredPrice + stairstepPrice - discount
  }

  getTotalMonthlyPrice(period: PeriodUnit, seats: number) {
    const periodPricing = this[period]

    const seatsPrice = periodPricing.perSeat?.getMonthlyPrice(seats) || 0
    const feePrice = periodPricing.fee?.getMonthlyPrice() || 0
    const tieredPrice = periodPricing.tiered?.getMonthlyPrice() || 0
    const stairstepPrice = periodPricing.stairstep?.getMonthlyPrice() || 0
    const discount = this._discount

    return seatsPrice + feePrice + tieredPrice + stairstepPrice - discount
  }
}
